import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyA2R4vO0eky3hYsNFevkynzJQRX8I4Ra0M",
    authDomain: "opencovid19-64bb9.firebaseapp.com",
    databaseURL: "https://opencovid19-64bb9.firebaseio.com",
    appId: "1:1098709948288:web:c7ed87404a5811b88e1365",
    projectId: "opencovid19-64bb9",
};
firebase.initializeApp(config);
export const auth = firebase.auth;
export const db = firebase.firestore();